import { render, staticRenderFns } from "./v80a1080.vue?vue&type=template&id=8fc6cf96&scoped=true"
import script from "./v80a1080.vue?vue&type=script&lang=js"
export * from "./v80a1080.vue?vue&type=script&lang=js"
import style0 from "./v80a1080.vue?vue&type=style&index=0&id=8fc6cf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6cf96",
  null
  
)

export default component.exports